import { ACTION_NAMES, getAppIsolate } from '../../actions/actions';
import { extractErrMsg } from '../../utils/utils';

const initialState = {};

export const isolateRedirect = () => dispatch => {
  dispatch({ type: ACTION_NAMES.APP_ISOLATE_START });
  const queryParams = window.location.search;
  getAppIsolate(queryParams).then(res => {
    if (res.status === 200) {
      dispatch({
        type: ACTION_NAMES.APP_ISOLATE_SUCCESS,
        response: res.data,
      });
    }
    if (res.status === 202) {
      dispatch({
        type: ACTION_NAMES.APP_ISOLATE_OIDC_SUCCESS,
        redirectURL: res.data.redirect_url,
      });
    }
    if (res.status >= 400) {
      const errorMessage = extractErrMsg(res, true);
      const error = res?.data || {};
      dispatch({
        type: ACTION_NAMES.APP_ISOLATE_FAIL,
        error,
        errorMessage,
      });
    }
  }).catch(res => {
    const errorMessage = extractErrMsg(res, true);
    const error = res?.response?.data || {};
    dispatch({
      type: ACTION_NAMES.APP_ISOLATE_FAIL,
      error,
      errorMessage,
    });
  });
};

export default function isolatePageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACTION_NAMES.APP_ISOLATE_SUCCESS:
      return { ...state, samlData: action.response };
    case ACTION_NAMES.APP_ISOLATE_OIDC_SUCCESS:
      return { ...state, redirectURL: action.redirectURL };
    case ACTION_NAMES.APP_ISOLATE_FAIL:
      return { ...state,
        error: action.error,
        errorMessage: action.errorMessage };
    default:
      return { ...state };
  }
}
